import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import shuffle from 'lodash/shuffle';
import { useEffect, useState } from 'react';
export const RandomizingList = ({ items }) => {
    const [shuffledItems, setShuffledItems] = useState(shuffle(items));
    useEffect(() => {
        const interval = setInterval(() => {
            setShuffledItems((currShuffledItems) => shuffle(currShuffledItems));
        }, 2000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    return (_jsx("ul", { children: shuffledItems.map((item, i) => (_jsx("li", { children: item }, i))) }));
};
